<template>
  <div id="payment">
    <div class="container">
      <div class="page-title">
        <span>{{ branchName }}</span>
        <button class="btn btn-primary" @click="save">{{ $t("save") }}</button>
      </div>
      <Tabs>
        <TabSection :title="$t('branch.payment.account_1')" collapsible>
          <RecipientAccount ref="payment" :recipient-account="recipientAccount" />
        </TabSection>
      </Tabs>
    </div>
  </div>
</template>

<script>
  import RecipientAccount from "@/views/companies/settings/RecipientAccount";
  import { mapActions } from "vuex";

  export default {
    name: "BranchPayment",

    components: { RecipientAccount },

    data() {
      return {
        branchId: null,
        branchName: null,
        recipientAccount: null
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "branch.payment.title";
      this.$store.state.pageIcon = "";
      this.branchId = this.$route.query.branch;

      if (this.branchId) {
        await this.load();
      } else {
        await this.$router.push("/");
      }
    },

    methods: {
      ...mapActions(["getBranch", "saveBranch"]),

      async load() {
        this.$store.commit("showSpinner", true);
        let branch = await this.getBranch({
          branchId: this.branchId,
          augment: 'recipient'
        })
        this.$store.commit("showSpinner", false);

        if (branch) {
          this.branchName = branch.name
          this.recipientAccount = branch.recipientAccount;
        }
      },

      async save() {
        await this.saveBranch({
          branchId: this.branchId,
          augment: 'recipient',
          data: {
            recipientAccount: this.$refs.payment.getData()
          }
        });
        toast(this.$t("branch.success"), "success");
      }
    }
  }
</script>

<style lang="scss" scoped>
  #payment {
    display: flex;
  }
</style>